import React from 'react';
import { AlertTriangle } from '@untitledui/icons';

import CmButton from '../primitives/CmButton';
import styles from './EmptyState.module.css';

interface ErrorStateBaseProps {
  title: React.ReactNode;
  message?: React.ReactNode;
  testId?: string;
}

// Retry is opt-in: when a caller wires an onRetry handler, the retryLabel is
// required so the button can never render with a hard-coded English fallback.
// TS enforces the pairing — pass both or neither.
type ErrorStateWithoutRetry = ErrorStateBaseProps & {
  onRetry?: undefined;
  retryLabel?: undefined;
};
type ErrorStateWithRetry = ErrorStateBaseProps & {
  onRetry: () => void;
  retryLabel: React.ReactNode;
};
export type ErrorStateProps = ErrorStateWithoutRetry | ErrorStateWithRetry;

export function ErrorState({
  title,
  message,
  onRetry,
  retryLabel,
  testId,
}: ErrorStateProps): React.ReactElement {
  return (
    <div className={styles.error} data-testid={testId}>
      <span className={styles.icon} aria-hidden="true">
        <AlertTriangle width={32} height={32} />
      </span>
      <div className={styles.title}>{title}</div>
      {message ? <div className={styles.message}>{message}</div> : null}
      {onRetry ? (
        <div style={{ marginTop: '0.85rem' }}>
          <CmButton variant="ghost" onClick={onRetry}>
            {retryLabel}
          </CmButton>
        </div>
      ) : null}
    </div>
  );
}

export default ErrorState;
